import { render, staticRenderFns } from "./waterL.vue?vue&type=template&id=0dada124&scoped=true&"
import script from "./waterL.vue?vue&type=script&lang=js&"
export * from "./waterL.vue?vue&type=script&lang=js&"
import style0 from "./waterL.vue?vue&type=style&index=0&id=0dada124&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dada124",
  null
  
)

export default component.exports